
import { defineComponent } from 'vue'

import { getDefaultAvatar } from '~/utils/ui'

/**
 * Card to display account (workspace) details. Works for team and personal accounts
 */
export default defineComponent({
  name: 'AccountCard',
  props: {
    avatar: {
      type: String,
      default: ''
    },
    login: {
      type: String,
      default: ''
    },
    numMembersTotal: {
      type: Number,
      default: 0
    },
    isViewerPrimaryUser: {
      type: Boolean,
      default: false
    },
    roleInGroup: {
      type: String,
      default: ''
    },
    activeRepositoryCount: {
      type: Number,
      default: 0
    },
    vcsProvider: {
      type: String,
      default: ''
    }
  },
  methods: {
    getDefaultAvatar
  },
  computed: {
    vcsProviderIcon(): string {
      return this.$providerMetaMap[this.vcsProvider.toLowerCase()].icon
    },
    vcsProviderName(): string {
      return this.$providerMetaMap[this.vcsProvider.toLowerCase()].text
    },
    workspaceLink(): string {
      return `/${this.vcsProvider.toLowerCase()}/${this.login}`
    },
    role(): 'ADMIN' | 'OWNER' | '' {
      if (this.roleInGroup === 'ADMIN') {
        if (this.isViewerPrimaryUser) return 'OWNER'
        return 'ADMIN'
      }
      return ''
    },
    showRoleTag(): boolean {
      return this.role === 'ADMIN' || this.role === 'OWNER'
    },
    tagBgColor(): string {
      if (this.role === 'ADMIN') {
        return 'ink-50'
      }
      if (this.role === 'OWNER') {
        return 'robin-400'
      }
      return ''
    },
    tagTextColor(): string {
      if (this.role === 'ADMIN') {
        return 'text-vanilla-400'
      }
      if (this.role === 'OWNER') {
        return 'text-ink-400'
      }
      return ''
    }
  }
})
